import { Component, Input, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FullTimelineEvent } from '../../../../../core/services/order-timeline/order-timeline-event.model';
import { OrderFullTimelineItemComponent } from './order-full-timeline-item/order-full-timeline-item.component';
import { AlertComponent } from '../../../../../shared/components/alert/alert.component';

@Component({
  selector: 'app-order-full-timeline',
  standalone: true,
  imports: [CommonModule, FormsModule, OrderFullTimelineItemComponent, AlertComponent],
  templateUrl: './order-full-timeline.component.html',
})
export class OrderFullTimelineComponent {
  @Input() loading = false;
  @Input() error: string | null = null;
  @Input() set data(value: unknown) {
    this.rawData.set(value);
  }

  private readonly rawData = signal<unknown>(null);
  searchTerm = signal('');

  events = computed<FullTimelineEvent[]>(() => {
    const raw = this.rawData();
    if (!raw) return [];

    if (Array.isArray(raw)) {
      return raw as FullTimelineEvent[];
    }

    if (typeof raw === 'object' && raw !== null) {
      const obj = raw as Record<string, unknown>;
      for (const key of Object.keys(obj)) {
        if (Array.isArray(obj[key])) {
          return obj[key] as FullTimelineEvent[];
        }
      }
    }

    return [];
  });

  filteredEvents = computed<FullTimelineEvent[]>(() => {
    const all = this.events();
    const term = this.searchTerm().toLowerCase().trim();
    if (!term) return all;

    return all.filter((event) => {
      const origin = (event.eventOrigin ?? '').toLowerCase();
      const target = (event.eventTarget ?? '').toLowerCase();
      const description = (event.description ?? '').toLowerCase();
      const name = (event.name ?? '').toLowerCase();
      const kind = (event.kind ?? '').toLowerCase();

      if (
        origin.includes(term) ||
        target.includes(term) ||
        description.includes(term) ||
        name.includes(term) ||
        kind.includes(term)
      ) {
        return true;
      }

      if (event.data != null) {
        try {
          const dataStr = JSON.stringify(event.data).toLowerCase();
          return dataStr.includes(term);
        } catch {
          return false;
        }
      }

      return false;
    });
  });

  onSearchInput(value: string): void {
    this.searchTerm.set(value);
  }
}
